module.exports = __webpack_public_path__ + "img/data-item3-4.b6c9055.png";